"use client";

import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";

export default function TopHeader() {
  const pathname = usePathname();
  const [user, setUser] = useState<{ branchName?: string } | null>(null);

  useEffect(() => {
    fetch("/api/auth/me")
      .then((res) => res.json())
      .then((data) => {
        if (data.user) setUser(data.user);
        else setUser(null);
      })
      .catch(() => {});
  }, [pathname]);

  if (!user?.branchName) return null;

  return (
    <div style={{
      position: "fixed",
      top: 0,
      right: 0,
      padding: "12px 24px",
      zIndex: 50,
      display: "flex",
      alignItems: "center",
      gap: "8px",
      background: "rgba(255, 255, 255, 0.8)",
      backdropFilter: "blur(8px)",
      borderBottomLeftRadius: "12px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      border: "1px solid #e2e8f0",
      borderTop: "none",
      borderRight: "none"
    }}>
      <span style={{ fontSize: "16px" }}>🏢</span>
      <span style={{ 
        fontWeight: 700, 
        color: "#1e293b",
        fontSize: "15px",
        letterSpacing: "-0.3px"
      }}>
        {user.branchName}
      </span>
    </div>
  );
}
